export default "__VITE_PUBLIC_ASSET__67595367__"